import { put, call, select, takeLeading } from 'redux-saga/effects';

import { Routes } from 'constants/routes';

import * as $auth from 'modules/auth';
import { fetchUserProfile } from 'modules/userProfile/sagas/fetchUserProfile';
import { fetchArtProducts } from 'modules/arts/sagas/fetchArts';
import * as actions from '../actions';

const getOnboardingSteps = function* () {
  const initialOnboardingSteps = [
    {
      number: 1,
      title: 'Create an Account',
      status: 'completed',
    },
    {
      number: 2,
      title: 'Verify Email',
      status: null,
      route: Routes.ProfileEmail,
    },
    {
      number: 3,
      title: 'Complete Your Profile',
      status: null,
    },
    {
      number: 4,
      title: 'Upload First Artwork',
      status: null,
      route: Routes.Arts.CreateArt,
    },
    {
      number: 5,
      title: 'Publish Profile & Work',
      status: null,
      route: Routes.ProfilePublish,
    },
  ];

  const onboardingSteps = initialOnboardingSteps;
  try {
    const user = yield select($auth.getCurrentUser);
    onboardingSteps[1].status = user.isEmailVerified ? 'completed' : 'upcoming';

    const userProfile = yield call(fetchUserProfile, user.id);
    onboardingSteps[2].status = userProfile ? 'completed' : 'upcoming';

    const artProducts = yield call(fetchArtProducts);
    onboardingSteps[3].status = artProducts.length > 0 ? 'completed' : 'upcoming';

    const isUserProfilePublished = yield select($auth.getIsCurrentUserProfilePublished);
    onboardingSteps[4].status = isUserProfilePublished ? 'completed' : 'upcoming';

    return onboardingSteps;
  } catch {
    return initialOnboardingSteps;
  }
};

const updateOnboardingSteps = function* () {
  const onboardingSteps = yield call(getOnboardingSteps);
  yield put(actions.setOnboardingSteps(onboardingSteps));
};

export const onboardingSaga = function* () {
  yield takeLeading(actions.updateOnboardingSteps, updateOnboardingSteps);
};
